import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ITEMS = [
    "Quer comer melhor",
    "Tem alergias ou intolerâncias",
    "Quer emagrecer",
    "Quer ganhar massa",
    "Cuida da pressão, açúcar ou colesterol",
    "Compra para filhos, pais ou família",
    "Não quer depender de letras miúdas",
    "Quer decidir rápido no mercado",
];

export default function ParaQuem() {
    return (
        <section
            id="para-quem"
            data-testid="para-quem-section"
            className="relative py-20 md:py-28 bg-[#F8FAFC] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                        Para quem é
                    </span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                        Feito para quem quer escolher melhor.
                    </h2>
                </motion.div>
            </div>

            <div className="mt-14">
                <Marquee
                    gradient
                    gradientColor="#F8FAFC"
                    gradientWidth={120}
                    speed={38}
                    pauseOnHover
                >
                    {ITEMS.map((t) => (
                        <div
                            key={t}
                            data-testid={`para-quem-chip-${t.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                            className="mx-2 my-1 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-slate-100 text-[#0B1C3A] font-semibold shadow-[0_6px_20px_rgba(11,28,58,0.04)]"
                        >
                            <span className="h-6 w-6 rounded-full bg-[#16A34A]/12 grid place-items-center text-[#16A34A]">
                                <Check size={14} strokeWidth={3} />
                            </span>
                            {t}
                        </div>
                    ))}
                </Marquee>
                <div className="mt-4">
                    <Marquee
                        gradient
                        gradientColor="#F8FAFC"
                        gradientWidth={120}
                        speed={32}
                        direction="right"
                        pauseOnHover
                    >
                        {ITEMS.slice()
                            .reverse()
                            .map((t) => (
                                <div
                                    key={`r-${t}`}
                                    className="mx-2 my-1 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-slate-100 text-[#0B1C3A] font-semibold shadow-[0_6px_20px_rgba(11,28,58,0.04)]"
                                >
                                    <span className="h-6 w-6 rounded-full bg-[#2563EB]/10 grid place-items-center text-[#2563EB]">
                                        <Check size={14} strokeWidth={3} />
                                    </span>
                                    {t}
                                </div>
                            ))}
                    </Marquee>
                </div>
            </div>
        </section>
    );
}
